<ng-container *ngIf="canContinue">
        <div class="modal-header">
        <h4 id="modal-label-3" class="modal-title">Inscription a l'évènement</h4>
        <!-- <button aria-hidden="true" data-dismiss="modal" class="close" type="button">×</button> -->
        </div>

        <app-cllajinscriptionuser (onNextStep)="goPart2($event)" (onClose)="close($event)" *ngIf="inscriptionService.form.step == 1"></app-cllajinscriptionuser>
        <app-cllajinscriptionlieux (onNextStep)="goPart3($event)" (onPrevStep)="goPart1($event)" *ngIf="inscriptionService.form.step == 2"></app-cllajinscriptionlieux>
        <app-cllajinscriptionsalons (onNextStep)="goPart4($event)" (onPrevStep)="goPart2($event)" *ngIf="inscriptionService.form.step == 3"></app-cllajinscriptionsalons>

        <div *ngIf="inscriptionService.form.step == 4" >
            <div class="modal-body">
                <div class="row">
                <div class="col-lg-12">
                    <h5>Merci!</h5>
                    <p>
                        <strong>Ton inscription a bien été prise en compte.</strong>
                        <br/>
                    </p>

                    <ng-container *ngFor="let item of finalForm.lieux.selectedItems">
                    <p>
                        Nous t'attendons le  {{ item.dateDebut | date:"shortDate" }} dès 9h à :<br/>
                    {{ item.description }}
                </p>
                </ng-container>

        <p>Suis toutes les dernières actualités du forum sur les réseaux sociaux du CLLAJ Martinique !</p>

            <p *ngIf="hasOnlySP() || hasOnlyD() || hasOnlySPD()">




                <ng-container *ngIf="hasOnlySP()">
                    <strong>Comme tu as choisi l'activité Speed Dating</strong>,
                    <br/>Dépose ta demande sur la plateforme D'Clic Jeune.<br/>
                    Puis rends-toi au Forum, avec ta pièce d'identité.<br/><br/>
                    Puis rends-toi au Forum, avec <strong class="text-red">ta pièce d'identité</strong>.<br /><br />
                    <strong>Clique sur le bouton ci-dessous pour continuer:</strong><br/>
                    <a href="https://cllaj-martinique.fr/annonces/inscription.php?ref=Forum_SP" target="_blank" class="btn btn-b"><i class="fas fa-right"></i> Plateforme D'Clic Jeune</a></ng-container>
                <ng-container *ngIf="hasOnlyD()" >
                    <strong>Comme tu as choisi l'activité Traitement de la demande</strong>,
                    <br/>Consulte les annonces du CLLAJ Martinique sur la plateforme D'Clic Jeune.
                    <br/>Dépose ta demande sur la plateforme D'Clic Jeune.<br/>
                    Puis rends-toi au Forum, avec <strong class="text-red">ta pièce d'identité</strong>.<br /><br />
                    <strong>Clique sur le bouton ci-dessous pour continuer:</strong><br/>
                    <a href="https://cllaj-martinique.fr/annonces/annonces-logement.php?ref=Forum_D" target="_blank" class="btn btn-b"><i class="fas fa-right"></i>Plateforme D'Clic Jeune</a></ng-container>
                <ng-container *ngIf="hasOnlySPD()" >
                    <strong>Comme tu as choisi l'activité Speed Dating et Traitement de la demande</strong>,
                    <br/>Consulte les annonces du CLLAJ Martinique sur la plateforme D'Clic Jeune.
                    <br/>Dépose ta demande sur la plateforme D'Clic Jeune.<br/>
                    Puis rends-toi au Forum, avec <strong class="text-red">ta pièce d'identité</strong>.<br /><br />
                    <strong>Clique sur le bouton ci-dessous pour continuer:</strong><br/>
                    <a href="https://cllaj-martinique.fr/annonces/annonces-logement.php?ref=Forum_SPD" target="_blank" class="btn btn-b"><i class="fas fa-right"></i> Plateforme D'Clic Jeune</a></ng-container>

            </p>




        <!-- {{ finalForm | json}} -->
                </div>

            </div>
            <div class="modal-footer">
                <button class="btn btn-success btn-b" type="button" (click)="close()">
                Terminer
                </button>
            </div>
        </div>
    </div>
</ng-container>
